<div class="_communication-template-mobile-page">
    <mobile-blocker-component></mobile-blocker-component>
</div>
